




import Vue from 'vue';
import CommonError from '@/components/common/common-error.component.vue';

export default Vue.extend({
  components: {
    'common-error': CommonError
  }
});
